import React, { useEffect } from 'react';
import { connect } from 'react-redux';
//Actions
import { logGet } from '../../../actions/log';
//Components
import LogDate from '../LogDate';
import VisitorVehicle from './VisitorVehicle';
import Loader from 'locki-dashboard-navigation/dist/loader';
import Table from 'locki-dashboard-navigation/dist/table';
//Material-ui
import Paper from '@material-ui/core/Paper';

function PassesLog({ clan, log, logGet }) {
  useEffect(() => {
    logGet('pass', clan);
  }, []);

  const data = log ? log.pass : undefined;

  const columns = [
    {
      id: 'date',
      align: 'left',
      padding: 'none',
      label: 'Fecha',
      component: LogDate,
    },
    { id: 'address', align: 'right', label: 'Domicilio' },
    { id: 'hostName', align: 'right', label: 'Residente' },
    {
      id: 'visitorVehicleUrl',
      align: 'right',
      label: 'Vehiculo',
      component: VisitorVehicle,
    },
    { id: 'name', align: 'right', padding: 'none', label: 'Visitante' },
  ];
  const table = (
    <Paper className="general-paper">
      <Table data={data} order="desc" columns={columns} title="Registro" />
    </Paper>
  );
  return data === undefined ? <Loader /> : table;
}

const mapStateToProps = (state) => ({
  log: state.log,
});

const mapDispatchToProps = (dispatch) => ({
  logGet: (method, clan) => dispatch(logGet(method, clan)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PassesLog);
